import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useAppDispatch } from '~/redux/hooks';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import {
  useGetUserProfileQuery,
  useSendOtpMutation,
} from '~/redux/api/authApiSlice';
import { objectSerialize } from '~/lib';
import OtpModal from '~/components/OtpModal';
import { useBreakpoint } from '~/hooks';

export default function VerifyPhoneButton() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();
  const [sendOtp] = useSendOtpMutation();
  const { data: userProfile } = useGetUserProfileQuery();

  const handleSendOtp = async () => {
    const formData = objectSerialize({ temporaryPhone: userProfile?.phone });
    const response = await sendOtp(formData);
    if (response && !response.error) {
      dispatch(openModal('otpModal'));
    }
  };

  return userProfile.is_phone_verified ? (
    <Icon name="verify" className="text-green_light" />
  ) : (
    <>
      <Button
        size="small"
        onClick={handleSendOtp}
        className="text-red_dark"
        ariaLabel="verify-phone"
        variant="secondary"
        Icon={<Icon name="verify" size="16px" />}
      >
        <span className="text-link md:text-caption_2 font-bold ">
          {t(mobileScreen ? 'verify' : 'verifyPhoneNumber')}
        </span>
      </Button>
      <OtpModal
        title={t('checkPhoneNumber')}
        description={
          <p className="text-body_1 text-gray__dark_1">{t('enterOtp')}</p>
        }
        phone={userProfile?.phone}
      />
    </>
  );
}
